import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPartyHorn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.57069 14.5L9.46522 18.4141M18.999 3.60975C17.4038 3.59505 16.6652 4.33233 16.423 5.07743C16.2097 5.73354 16.4046 7.07735 15.8954 8.0727C15.4085 9.02443 14.1197 9.5617 12.6565 9.60697M19.9994 7.6104L20.0094 7.61049M18.9994 15.96L19.0094 15.9601M6.9994 3.94926L7.0094 3.94936M18.9994 11.1094C17.4994 11.1094 16.4994 11.6094 15.5943 12.5447M10.2371 7.18796C10.9994 6.10991 11.4994 5.10991 11.0076 3.52734M3.53516 20.4645L7.07069 9.85791L14.1418 16.929L3.53516 20.4645Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPartyHorn;
